import axios from '@/components/api/axios';

async function getInformation(notificationId) {
  let data = {
    notificationId: notificationId
  }
  const res = await axios.axiosGet('/api/notifications/getInformation', data);
  return res;
}

export default {
  getInformation
}



// WEBPACK FOOTER //
// ./src/components/api/notifications.js